export default __webpack_public_path__ + "static/media/download.3b169a0f.svg";